export default __webpack_public_path__ + "static/media/logo_bcrcr.e13315b5.svg";